// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBf0VIYcbvv9OxJJYCIpYaGExPbMikjBBA",
    authDomain: "neverland-test-e2d46.firebaseapp.com",
    projectId: "neverland-test-e2d46",
    storageBucket: "neverland-test-e2d46.firebasestorage.app",
    messagingSenderId: "676358906619",
    appId: "1:676358906619:web:d75c7ffdb5c435487c065e"
  },
  serverURL: 'https://test.neverland.ai.kr',
  deepLinkURL: 'https://link.neverland.ai.kr',
  // serverURL: 'http://localhost:8100',
  sns: {
    googleClientId: '840306522108-6i3ecf2v3v2rmgj56bgrtk9kuslrb7pq.apps.googleusercontent.com',
  },
  firebasefFunc: {
    jwtDecode: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/jwtDecode',

    socialSignup: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/socialFunctions/socialSignup',
    socialLogin: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/socialFunctions/socialLogin',
    socialConnect: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/socialFunctions/socialConnect',
    neverGetInfo: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/socialFunctions/neverGetInfo',
    googleLoginInfo: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/googleLoginInfo',

    searchLocal2: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/searchLocal2',
    searchLocal3: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/searchLocal3',

    deleteUser: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/socialFunctions/deleteUser',

    autoRefundProcess: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/autoRefundProcess',

    paymentStore: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/createHeartPayment',
    paymentCasting: 'https://us-central1-neverland-test-e2d46.cloudfunctions.net/createCastingPayment',

    documentAccessToken: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/createEformsignSignature',
    documentCreate: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/createEformsignDocument',
    documentCreateAttach: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/createEformsignDocumentAttach',

    profileThumbnail: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/profileThumbnail',
    getThumbnailFromVideo: 'https://thumbnail-service-676358906619.asia-northeast3.run.app/thumbnail',
    getDurationMedia: 'https://thumbnail-service-676358906619.asia-northeast3.run.app/duration',
    getMediaMetadata: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/getMediaMetadata',

    wordToHtml: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/wordToHtml',
    htmlToWord: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/htmlToWord',
    contractDocCreate: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/contractDocCreate',

    elevenlabsEnableCheck: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/elevenlabsEnableCheck',
    elevenlabsVoiceMake: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/elevenlabsVoiceMake',
    vmonsterVideoMake: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/vmonsterVideoMake',
    hedraVideoMake: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/hedraVideoMake',

    elevenlabsVoiceMakeUser: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/elevenlabsVoiceMakeUser',
    vmonsterVideoMakeUser: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/vmonsterVideoMakeUser',
    
    geminiChat: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChat',
    geminiChatFuncVideo: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncVideo',
    geminiChatFuncImage: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncImageText',
    geminiChatFuncWebPage: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncWebPage',
    geminiChatFuncGoogle: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncGoogle',
    geminiChatFuncGoogleInfo: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncGoogleInfo',
    geminiChatFuncDate: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/geminiChatFuncDate',

    vertaxCelebRecommendImg: 'https://asia-northeast3-neverland-test-e2d46.cloudfunctions.net/vertaxCelebRecommendImg',
  },

  onesignalID: '40cfeddf-0165-4b4b-bb49-05bd604fd04d',
  onesignalAndroidChannelId: '19dd4a76-dbc8-4933-a658-44152817ffe1',
  onesignalAuth: 'os_v2_app_zoezbzaagbfvlp47g3bve72dt5i3zvss74kuq3n3kru3feix46bngfho4e3fmrujm6zsd2oy3ppjvzwbbwohwoi3kq3z4onnqbpn4ty',
  
  facebookSecret: '7adcabd154a46b69b913209dbbcd7a5e',
  
  chatGptSecret: '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',
  elevenlabsApiKey: 'sk_b249428bd3b564b08df263ce45e698c688151aa0f4620c95',  // dioh@artsurn.net
  didApiKey: 'ZGlvaEBhcnRzdXJuLm5ldA:D91EZEKF95lorhSma6NLq',
  geminiKey: 'AIzaSyCmuW5eyrch5rqicZNWA9_-Mm5jJfQ72do',
  googleSearchKey: 'AIzaSyAnJyJ77qdxKYGiD2jJePXLUKe0cjrzbjA',
  googleSearchEnginId: '45404e46866404543',
  ejelKey: 'fhI8EfBXyyPjXsOl4qxmb3Z0vH2AiFnY',
  wssUrl: 'wss://speech-streamer-840306522108.asia-northeast3.run.app',
  // wssUrl: 'ws://localhost:8080',

  branchKey: 'key_live_gBtdBGTKeOLCfQRBhyvvpjmnCzmkAf6S',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
